import React from 'react';

import { useDocsPageContext } from '../../../hooks/useDocsPageContext';

import Loading from '../../../components/Loading';
import RootFolderNavItem from '../RootFolderNavItem/RootFolderNavItem';
import SidePanelFolderNavList from '../SidePanelFolderNavList/SidePanelFolderNavList';

const FolderNavBar = () => {
    const { sidePanelFolders, expandedFolders } = useDocsPageContext();

    return (
        <div className="flex-1 flex flex-col gap-1 overflow-y-auto -mr-5 pr-5">
            <RootFolderNavItem />

            {sidePanelFolders && (
                <SidePanelFolderNavList
                    sidePanelFolders={sidePanelFolders}
                    expandedFolders={expandedFolders}
                />
            )}

            {!sidePanelFolders && (
                <div>
                    <Loading withText={false} />
                </div>
            )}
        </div>
    );
};

export default FolderNavBar;
